/** Every tab reads the same `lissen-play-outbox-v2` browser storage, so the
 *  tabs drain it one at a time: a tab waits for the one draining, then sends
 *  what that tab left. Without Web Locks, or when the browser refuses the
 *  lock, the tab drains anyway. */
export async function playOutboxLock(
  drain: () => Promise<void>,
): Promise<void> {
  let granted = false;
  try {
    const locks = globalThis.navigator?.locks;
    if (locks)
      return await locks.request("lissen-play-outbox-v2", async () => {
        granted = true;
        await drain();
      });
  } catch (error) {
    if (granted) throw error;
  }
  return drain();
}
